<template>
    <div>
        <b-card v-show="editMode===0">
            <b-row>
                <b-col sm="12" class="text-right">
                    <b-btn-group size="sm">
                        <b-button variant="white" class="button-icon-only mr-1" title="Обновить"
                                  @click="buttonRefreshClicked"
                        >
                            <i class="fa fa-sync"/>
                        </b-button>
                        <b-button v-show="userActionAccessArray['new']" variant="success" @click="buttonAddClicked">
                            <i class="fa fa-plus"/> Новая запись
                        </b-button>
                    </b-btn-group>
                </b-col>
            </b-row>
            <MyToolbar>
                <MyToolbarItem>
                    <b-input v-model="searchQuickFilter" @keyup.prevent.enter="buttonSearchClicked" maxlength="200"
                             size="sm" placeholder="Поиск..." ref="inputQuickFilter" @keyup.esc="searchQuickFilter=''"
                    />
                </MyToolbarItem>
                <MyToolbarItem>
                    <b-input-group>
                        <b-input-group-prepend>
                            <label for="select-subscriber-type" class="mt-2">Тип:</label>
                        </b-input-group-prepend>
                        <b-select id="select-subscriber-type" :options="searchSubscriberTypeList"
                                  v-model="searchSubscriberTypeUid" @change="buttonSearchClicked"
                                  style="margin-left: 10px; width: 150px" size="sm"
                        />
                    </b-input-group>
                </MyToolbarItem>
                <MyToolbarItem>
                    <b-input-group>
                        <b-form-checkbox switch size="lg" id="check-search-by-main-columns" class="ml-1 mt-1"
                                         v-model="searchByMainColumns" @change="buttonSearchClicked"
                        />
                        <b-input-group-append>
                            <label for="check-search-by-main-columns" class="mt-2">
                                Поиск по основным реквизитам
                            </label>
                        </b-input-group-append>
                    </b-input-group>
                </MyToolbarItem>
                <MyToolbarItem>
                    <b-button size="sm" variant="secondary" @click="buttonSearchClicked">Поиск</b-button>
                    <b-button size="sm" :variant="sortMode===0 ? 'secondary' : 'primary'" title="Расширенный поиск"
                              class="button-icon-only-normal ml-2"
                              @click="buttonAdvSearchShowClicked"
                    >
                        <i class="fas fa-cog"/>
                    </b-button>
                </MyToolbarItem>
            </MyToolbar>

            <b-alert :show="err" :variant="errVariant" class="mb-4">{{errText}}</b-alert>

            <b-table outlined hover head-variant="light" :fields="subscriberListFields" :items="subscriberList"
                     responsive="responsive" :no-local-sorting="true" sort-by="SubscriberName"
                     @row-clicked="tableRowClicked"
                     @sort-changed="sortChanged"
            >
            </b-table>
            <b-row>
                <b-col sm="6">
                    <b-pagination first-number last-number
                                  v-model="recordCurrentPageNumber" @input="loadSubscriberList"
                                  :total-rows="recordTotalNumber" :per-page="recordCountPerPage"
                    />
                </b-col>
                <b-col sm="6">
                    <div class="custom-items-per-page-div">
                        <label>Показать записей:</label>
                        <b-form-select id="input-records-per-page" size="sm" style="margin-left: 10px;width:65px"
                                       :options="recordCountPerPageArray" v-model="recordCountPerPage"
                                       @change="loadSubscriberList"
                        />
                    </div>
                </b-col>
            </b-row>

        </b-card>

        <b-card v-show="editMode===1" title="Просмотр записи">
            <b-alert :show="err" :variant="errVariant" class="mb-3">{{errText}}</b-alert>
            <b-form @reset.prevent="cancelRecord">
                <b-row>
                    <b-col md="12">
                        <b-form-group v-if="userActionAccessCompany" label="РЭК" label-for="input-edit-company">
                            <b-input id="input-edit-company" v-model="editCompany" @keyup.esc="cancelRecord"
                                     readonly="readonly" ref="inputEditCompany"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="РЭС" label-for="input-edit-res">
                            <b-input id="input-edit-res" v-model="editRes" @keyup.esc="cancelRecord"
                                     readonly="readonly" ref="inputEditRes"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Абонент" label-for="input-edit-subscriber-name">
                            <b-input id="input-edit-subscriber-name" v-model="editSubscriberName"
                                     @keyup.esc="cancelRecord"
                                     readonly="readonly"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Тип абонента" label-for="input-edit-subscriber-type">
                            <b-input id="input-edit-subscriber-type" v-model="editSubscriberType"
                                     @keyup.esc="cancelRecord"
                                     readonly="readonly"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Код 1с" label-for="input-edit-isCode">
                            <b-input id="input-edit-isCode" v-model="editISCode" @keyup.esc="cancelRecord"
                                     readonly="readonly"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col md="4">
                        <b-form-group label="Адрес" label-for="input-edit-address">
                            <b-input id="input-edit-address" v-model="editAddress" @keyup.esc="cancelRecord"
                                     readonly="readonly"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Телефон" label-for="input-edit-phone-number">
                            <b-input id="input-edit-phone-number" v-model="editPhoneNumber" @keyup.esc="cancelRecord"
                                     readonly="readonly"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col md="4">
                        <b-form-group label="Номер контракта" label-for="input-edit-contract-num">
                            <b-input id="input-edit-contract-num" v-model="editContractNum" @keyup.esc="cancelRecord"
                                     readonly="readonly"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Категория" label-for="input-edit-subscriber-category">
                            <b-input id="input-edit-subscriber-category" v-model="editSubscriberCategory"
                                     @keyup.esc="cancelRecord"
                                     readonly="readonly"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Номер счета" label-for="input-edit-bank-account-number">
                            <b-input id="input-edit-bank-account-number" v-model="editBankAccountNumber"
                                     @keyup.esc="cancelRecord"
                                     readonly="readonly"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Примечание" label-for="textarea-edit-description">
                            <b-textarea id="textarea-edit-description" v-model="editDescription" rows="2"
                                        readonly="readonly" @keyup.esc="cancelRecord"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Статус записи" label-for="input-edit-record-status">
                            <b-input id="input-edit-record-status" v-model="editRecordStatus" @keyup.esc="cancelRecord"
                                     readonly="readonly"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <hr/>
                <b-button type="reset" variant="secondary">Закрыть</b-button>
            </b-form>
        </b-card>

        <b-modal ref="modal-search" hide-footer centered title="Расширенный поиск" @hidden="modalHidden">
            <b-row>
                <b-col sm="12" v-if="userActionAccessCompany">
                    <b-form-group label="РЭК" label-for="input-AdvSearch-company">
                        <b-select id="input-AdvSearch-company" :options="searchCompanies"
                                  v-model="searchCompanyUid" autofocus @change="advSearchSelectCompanyChanged"
                                  @keyup.enter="buttonAdvSearchOkClicked"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group label="Лицевой счет" label-for="input-AdvSearch-isCode">
                        <b-input id="input-AdvSearch-isCode" v-model="searchIsCode"
                                 @keyup.enter="buttonAdvSearchOkClicked" maxlength="15"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group label="Имя абонента" label-for="input-AdvSearch-subscriberName">
                        <b-input id="input-AdvSearch-subscriberName" v-model="searchSubscriberName"
                                 @keyup.enter="buttonAdvSearchOkClicked" maxlength="150"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group label="Адрес" label-for="input-AdvSearch-address">
                        <b-input id="input-AdvSearch-address" v-model="searchAddress"
                                 @keyup.enter="buttonAdvSearchOkClicked" maxlength="200"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group label="Номер телефона" label-for="input-AdvSearch-phoneNumber">
                        <b-input id="input-AdvSearch-phoneNumber" v-model="searchPhoneNumber"
                                 @keyup.enter="buttonAdvSearchOkClicked" maxlength="20"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group label="Номер контракта" label-for="input-AdvSearch-contractNum">
                        <b-input id="input-AdvSearch-contractNum" v-model="searchContractNum"
                                 @keyup.enter="buttonAdvSearchOkClicked" maxlength="25"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group label="Статус записи" label-for="input-AdvSearch-record-status">
                        <b-select id="input-AdvSearch-record-status" :options="searchRecordStatuses"
                                  v-model="searchRecordStatus"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <div>
                <b-button variant="outline-danger" @click="buttonAdvSearchCancelClicked">Сбросить</b-button>
                <b-button variant="secondary" class="ml-2 float-right" @click="buttonAdvSearchCloseClicked">Закрыть
                </b-button>
                <b-button variant="primary" class="float-right" @click="buttonAdvSearchOkClicked">Поиск</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
    import MyToolbar from "@/view/components/MyToolbar";
    import MyToolbarItem from "@/view/components/MyToolbarItem";
    import axios from "axios";

    export default {
        name: "Subscribers",
        components: {MyToolbar, MyToolbarItem},
        data() {
            return {
                userData: this.$store.getters.getUserData,
                recordCountPerPageArray: this.$store.getters.getRecordCountPerPageArray || [],
                recordCountPerPage: this.$store.getters.getRecordCountPerPage || 20,
                recordCurrentPageNumber: 1,
                recordTotalNumber: 0,

                userActionAccessArray: [],
                userActionAccessCompany: 0,
                userActionAccessRes: 0,

                loadProcessing: 0,

                editMode: 0,
                addEditTitle: "",
                recordUid: "",
                recordVersion: "",

                err: false,
                errText: "",
                errVariant: "danger",

                searchQuickFilter: "",
                searchRecordStatus: -1,
                searchCompanyUid: 0,
                searchResUid: "",
                searchIsCode: "",
                searchSubscriberName: "",
                searchAddress: "",
                searchPhoneNumber: "",
                searchContractNum: "",

                searchSubscriberTypeList: [],
                searchSubscriberTypeUid: -1,
                searchRes: [{'value': "", 'text': '<все>'}],
                searchByMainColumns: true,

                sortMode: 0,    //0-simple, 1-advanced
                sortBy: "SubscriberName",
                sortDesc: false,

                searchRecordStatuses: [
                    {'value': -1, 'text': "<все>"},
                    {'value': 0, 'text': "готов"},
                    {'value': 1, 'text': "только чтение"},
                    {'value': 2, 'text': "заблокирован"},
                    {'value': 3, 'text': "на удаление"},
                    {'value': 4, 'text': "в архиве"},
                ],
                searchCompanies: [],

                subscriberList: [],
                subscriberListFields: [
                    {key: "RowNumber", label: "№", tdClass: "pointer"},
                    {key: "CompanyAlias", label: "РЭК", sortable: true, tdClass: "pointer"},
                    {key: "RES", label: "РЭС", sortable: true, tdClass: "pointer"},
                    {key: "ISCode", label: "ЛС", sortable: true, tdClass: "pointer"},
                    {key: "SubscriberName", label: "Абонент", sortable: true, tdClass: "pointer"},
                    {key: "SubscriberType", label: "Тип абонента", sortable: true, tdClass: "pointer"},
                    {key: "Address", label: "Адрес", tdClass: "pointer"},
                    {key: "PhoneNumber", label: "Номер телефона", tdClass: "pointer"},
                    {key: "ContractNum", label: "Номер контракта", tdClass: "pointer"},
                    {key: "RecordStatus", label: "Статус", sortable: true, tdClass: "pointer"},
                ],

                editCompany: "",
                editRes: "",
                editISCode: "",
                editSubscriberName: "",
                editAddress: "",
                editPhoneNumber: "",
                editSubscriberType: "",
                editContractNum: "",
                editSubscriberCategory: "",
                editBankAccountNumber: "",
                editDescription: "",
                editRecordStatus: "",

            }
        },
        created() {
            window.addEventListener('keydown', (e) => {
                if (e.key === 'Insert' && !e.ctrlKey && !e.altKey && !e.shiftKey) {
                    this.buttonAddClicked()
                }
            });

            this.userActionAccessArray = this.getUserActionAccessArray("RefsSubscribers", this.userData.UserAccess)
            this.userActionAccessCompany = this.getUserDataAccess("RefsCompanies", this.userData.UserAccess)
            this.userActionAccessRes = this.getUserDataAccess("RefsRES", this.userData.UserAccess)
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Справочники", route: "subscribers"},
                {title: "Абоненты"}
            ]);

            if (this.userData.UserGroupUid === 1) this.loadCompanies()

            //If not Admin - delete Company from the list
            if (this.userData.UserGroupUid !== 1) {
                let ind = this.subscriberListFields.findIndex(item => item.key.toLowerCase() === "companyalias");
                if (ind >= 0)
                    this.subscriberListFields.splice(ind, 1)
            }
            //If no Access to RefRES - delete RES from the list
            if (!this.userActionAccessRes) {
                let ind = this.subscriberListFields.findIndex(item => item.key.toLowerCase() === "res");
                if (ind >= 0)
                    this.subscriberListFields.splice(ind, 1)
            }

            //If no access to archive
            if (!this.userActionAccessArray['archive']) {
                let ind = this.searchRecordStatuses.findIndex(item => item.value === 4);
                if (ind >= 0)
                    this.searchRecordStatuses.splice(ind, 1)
            }

            this.loadSubscriberTypes()
            this.loadSubscriberList()

            this.$nextTick(() => {
                this.$refs.inputQuickFilter.$el.focus()
            })
        },
        methods: {
            errTextHide() {
                this.err = false
                this.errText = ""
            },
            errTextShow(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errText = msg
                this.errVariant = variant
                this.err = true
            },
            loadCompanies() {
                this.searchCompanies = [{'value': 0, 'text': "<все>"}]

                axios.post("/ws/ws.svc/GetRefsCompaniesArray", {
                        'Session_UID': this.userData.Session_UID,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.data.forEach(item => {
                                            this.searchCompanies.push({'value': item.UID, 'text': item.Alias})
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadSubscriberTypes() {
                this.searchSubscriberTypeList = [{'value': -1, 'text': "<все>"}]
                this.searchSubscriberTypeUid = -1

                if ((this.userData.UserGroupUid === 1) && (this.searchCompanyUid === 0)) return

                axios.post("/ws/ws.svc/GetRefsSubscriberTypesArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.searchCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.searchSubscriberTypeList.push({
                                                'value': item.UID,
                                                'text': item.SubscriberType
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            buttonRefreshClicked() {
                this.loadSubscriberList()
            },
            buttonAddClicked() {
                //this.errTextHide()

            },
            buttonSearchClicked() {
                this.recordCurrentPageNumber = 1
                this.loadSubscriberList()
            },
            buttonAdvSearchShowClicked() {
                this.$refs['modal-search'].show()
            },
            tableRowClicked(item) {
                this.errTextHide()

                this.recordUid = item.UID
                this.editCompany = ""
                this.editRes = ""
                this.editISCode = ""
                this.editSubscriberName = ""
                this.editAddress = ""
                this.editPhoneNumber = ""
                this.editSubscriberType = ""
                this.editContractNum = ""
                this.editSubscriberCategory = ""
                this.editBankAccountNumber = ""
                this.editDescription = ""
                this.editRecordStatus = ""

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRESSubscriber", {
                        'Session_UID': this.userData.Session_UID,
                        'F_UID': this.recordUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        console.log(resp.data.data)
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    let result = (JSON.parse(resp.data.data))

                                    this.editCompany = !this.isUndefined(result.CompanyAlias) ? result.CompanyAlias : ""
                                    this.editRes = result.RES.toString()
                                    this.editISCode = result.ISCode.toString()
                                    this.editSubscriberName = result.SubscriberName.toString()
                                    this.editAddress = result.Address.toString()
                                    this.editPhoneNumber = result.PhoneNumber.toString()
                                    this.editSubscriberType = result.SubscriberType.toString()
                                    this.editContractNum = result.ContractNum.toString()
                                    this.editSubscriberCategory = result.SubscriberCategory.toString()
                                    this.editBankAccountNumber = result.BankAccountNumber.toString()
                                    this.editDescription = result.Description.toString()
                                    this.editRecordStatus = result.RecordStatus.toString()
                                } else {
                                    this.errTextShow("Запись не найдена. Пожалуйста, обновите страницу.", "danger", true)
                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }

                        this.editMode = 1
                        this.loadProcessing--
                        if (this.userActionAccessCompany) {
                            this.$nextTick(() => {
                                this.$refs.inputEditCompany.$el.focus()
                            })
                        } else {
                            this.$nextTick(() => {
                                this.$refs.inputEditRes.$el.focus()
                            })
                        }
                    })
                    .catch(err => {
                        this.editMode = 1
                        this.loadProcessing--
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
            },
            sortChanged(e) {
                this.sortBy = e.sortBy
                this.sortDesc = e.sortDesc
                this.loadSubscriberList()
            },
            loadSubscriberList() {
                this.errTextHide()

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRESSubscribers", {
                        'Session_UID': this.userData.Session_UID,
                        'Page': this.recordCurrentPageNumber,
                        'RecordsPerPage': this.recordCountPerPage,
                        'SortField': this.sortBy,
                        'SortMode': (this.sortDesc ? 1 : 0),
                        'F_Company_UID': this.searchCompanyUid,
                        'F_RES_UID': this.searchResUid,
                        'F_QuickFilter': this.searchQuickFilter,
                        'F_ISCode': this.searchIsCode,
                        'F_SubscriberName': this.searchSubscriberName,
                        'F_SubscriberType_UID': this.searchSubscriberTypeUid,
                        'F_Address': this.searchAddress,
                        'F_PhoneNumber': this.searchPhoneNumber,
                        'F_ContractNum': this.searchContractNum,
                        'F_SearchByMainColumns': (this.searchByMainColumns) ? 1 : 0,
                        'F_RS': this.searchRecordStatus,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response) ||
                            this.isUndefined(resp.data.data) || this.isUndefined(resp.data.meta)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    this.subscriberList = JSON.parse(resp.data.data)
                                    if (!this.isUndefined(resp.data.meta.TotalRecordsAmount)) {
                                        this.recordTotalNumber = resp.data.meta.TotalRecordsAmount
                                    } else {
                                        this.errTextShow("Ошибка при получении общего кол-ва записей.", "danger", true)
                                    }
                                } else {
                                    this.recordTotalNumber = 0
                                    this.subscriberList = []

                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }
                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            modalHidden() {
                this.$nextTick(() => {
                    this.$refs.inputQuickFilter.$el.focus()
                })
            },
            buttonAdvSearchCancelClicked() {
                this.sortMode = 0
                this.searchCompanyUid = 0
                this.searchIsCode = ""
                this.searchSubscriberName = ""
                this.searchAddress = ""
                this.searchPhoneNumber = ""
                this.searchContractNum = ""
                this.searchRecordStatus = -1
                this.recordCurrentPageNumber = 1
                this.$refs['modal-search'].hide()
                this.loadSubscriberList()
            },
            buttonAdvSearchCloseClicked() {
                this.$refs['modal-search'].hide()
            },
            buttonAdvSearchOkClicked() {
                if (this.searchCompanyUid !== 0 || this.searchRecordStatus !== -1 || this.searchIsCode !== ""
                    || this.searchSubscriberName !== "" || this.searchAddress !== "" || this.searchPhoneNumber !== ""
                    || this.searchContractNum !== "") {
                    this.sortMode = 1
                    this.searchQuickFilter = ""
                } else {
                    this.sortMode = 0
                }

                this.recordCurrentPageNumber = 1
                this.loadSubscriberList()
                this.$refs['modal-search'].hide()
            },
            advSearchSelectCompanyChanged() {
                this.loadSubscriberTypes()
            },
            cancelRecord() {
                this.errTextHide()
                this.editMode = 0
            },
        },
        computed: {
            getEditControlStatus: function () {
                return (!this.userActionAccessArray["edit"] || this.currentRecordStatus > 0)
            },
        },
        watch: {
            loadProcessing: function () {
                this.$store.commit('set', ["showSpinner", this.loadProcessing > 0])
            },
        }
    }
</script>

<style scoped>

</style>